module.exports = __webpack_public_path__ + "components/nearest-webcams/static/webcam_placeholder-025fb9a3acfc9b0223d9a5c3d4c19671.jpg";